<template>
  <div class="kecheng">
    <kind-choose-view :ifImg="true" :is-jinpin="false" :show-kc="false" :type="15" :schoole="schoole" :kind="kind" :zy-id="zyId"
      @isOk="isOk" />
    <!-- 内容 -->
    <div class="kecent">
      <!-- <router-view /> -->
      <div v-for="(item, index) in list" :key="index" class="kecents" @click="imgxq(index, item)">
       
        <img style="border-radius:8px 8px 0 0 " :src="item.coachClassTypeImage">

        <div class="kecentsCen" :class="item.lineType == 2 ? 'boutique' : ''">
          <div class="kecentsCenTop twoEllipsis">

            {{ item.coachClassTypeName }}
          </div>
          <div v-if="item.curForms && item.curForms.length > 0" class="kecentsCenCen"
            :class="item.lineType == 2 ? 'boutiqueTxt' : ''">
            <span v-for="(curForms, curindex) in item.curForms" :key="curindex">
              {{ curindex != 0 ? '·' : '' }}{{ curForms }}
            </span>
          </div>
          <div class="kecentsCenBtm">
            <div class="w-b-100">
              <span class="price" :class="item.lineType == 2 ? 'boutiquePrice' : ''"><span class="tips">¥
                </span>{{ item.coachClassTypePrice }}</span>

            </div>
            <div class="more dis_flex">
              <img class="img" src="https://staticfile.xlcwx.com/m-images/yth/lzjxy/img/Home/Frame.png"
                object-fit="contain">
              人气值{{ item.commodityIdCount ? item.commodityIdCount : 0 }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 暂无课程 -->
    <div style="margin: 0 auto;" v-if="!list || list.length == 0">
      <el-empty description="暂无数据"></el-empty>
    </div>

    <div style="
        display: flex;
        justify-content: center;
        align-items: center;
        width: 30%;
        margin: 40px auto;
        margin-bottom: 80px;
      ">
      <el-pagination class="pagination" :total="total" :current-page="pageNum" :page-sizes="[12, 24, 28, 32]"
        :page-size="pageSize" :pager-count="5" layout="total, sizes, prev, pager, next, jumper"
        @current-change="handleCurrentChange" @size-change="handleSizeChange" />
    </div>
  </div>
</template>
<script>
import KindChooseView from '@/components/kindChooseViewktypevip.vue'

import { getDomain } from '@/api/cookies'

import { HomeClient } from "@/api/home";
const homeClient = new HomeClient();
export default {
  components: {
    KindChooseView
  },

  data() {
    return {
      imgList: {},
      list: {},
      search: {},
      pageSize: 12,
      pageNum: 1,
      total: 0,
      kind: null,
      zyId: null,
      schoole: null,
      domain: null,
      loading: null
    }
  },
  async beforeDestroy() {
    this.loading.close()
  },
  async created() {
    this.domain = getDomain()
    homeClient.getSurfacePcList({ type: 4, entrantsType: this.domain.entrantsType }).then((res) => {
      if (res.code == 0) {
        if (res.msg.length > 0) {
          this.imgList = res.msg[0]
        } else {
          this.imgList = {}
        }
      }
    })
    if (this.$route.query.kind) {
      this.kind = await Number(this.$route.query.kind)
      this.search.kind = await Number(this.$route.query.kind)
    }
    if (this.$route.query.zId) {
      this.zyId = await Number(this.$route.query.zId)
      this.search.zyId = await Number(this.$route.query.zId)
    }
    if (this.$route.query.schoole) {
      this.schoole = await Number(this.$route.query.schoole)
      this.search.school = await Number(this.$route.query.schoole)
    }
    await this.getList()
  },
  methods: {
    // 获取知识套餐列表
    getList() {
      this.loading = this.$loading({
        lock: true,
        text: '加载中',
        spinner: '',
        background: 'rgba(0, 0, 0, 0.2)'
      })
      homeClient.qbsJxyTutorial(
        {
          pageSize: this.pageSize,
          pageNum: this.pageNum,
          collegeId: this.search.school,
          projectId: this.search.kind,
          majorId: this.search.zyId,
          lineType: this.search.productLine ? this.search.productLine : 4,
          province: this.search.areaId == 1 ? undefined : this.search.areaId,
          className: this.search.name ? this.search.name : undefined,

        }
      ).then((res) => {
        for (const item of res.rows) {
          if (item.curForms) {
            item.curForms = item.curForms.split(',')
          }
        }
        this.list = res.rows
        this.total = res.total
        this.loading.close()
      }).catch(() => {
        this.loading.close()
      })
    },

    handleSizeChange(val) {
      this.pageSize = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.pageNum = val
      this.getList()
    },
    // 筛选
    isOk(val) {
      this.search = val
      this.pageNum = 1
      this.getList()
    },

    // 点击图片跳转到详情页
    imgxq(index) {

      const routeUrl = this.$router.resolve({
        name: '知识套餐课详情',
        query: {
          id: this.list[index].coachClassTypeId,
         
        }
      })
      window.open(routeUrl.href, '_blank')
    }
  }
}
</script>
<style lang="less" scoped>
.kecheng {
  width: 100%;
  height: 100%;
  background: #f5f7fa;
  overflow: hidden;

  // 内容
  .kecent {
    width: calc(1220px + 24px);
    height: auto;
    margin: 30px 0px 0px calc(50% - 610px);
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-wrap: wrap;
    background: #f5f7fa;

    .kecents {
      width: 287px;
      background: #ffffff;
      box-shadow: 0px 2px 4px 0px rgba(237, 239, 242, 0.7);
      cursor: pointer;

      margin: 0px 24px 24px 0px;
      border-radius: 8px 8px 8px 8px;
      // overflow: hidden;
      position: relative;

      img {
        width: 100%;
        height: 161px;
        cursor: pointer;
      }

      .boutique {
        width: 100%;
        margin: auto;
        height: 158px;
        position: relative;
        padding: 12px 16px 16px;
        background-image: url("https://staticfile.xlcwx.com/m-images/yth/lzjxy/img/Home/boutiqueBan.png");
        background-size: 100% 100%;

        .kecentsCenTop {
          color: #5a4629 !important;
        }

        .more {
          color: #5a4629 !important;
          font-size: 12px !important;
        }
      }

      .kecentsCen {
        width: 100%;
        margin: auto;
        height: 150px;
        position: relative;
        padding: 12px 16px 16px;

        .kecentsCenTop {
          /*  font-size: 18px;
          font-family: Microsoft YaHei-Regular;
          font-weight: 400;
          color: #333333;
          line-height: 26px; */
          font-size: 16px;
          font-family: Microsoft YaHei-Regular, Microsoft YaHei;
          font-weight: 400;
          color: #333333;
          line-height: 24px;
          height: 48px;
          position: relative;
        }

        .kecentsCenCen {
          margin-top: 12px;
          height: 20px;
          background-color: #fff2e9;
          border-radius: 2px 2px 2px 2px;
          display: inline-block;
          opacity: 1;
          padding: 0px 8px;
          line-height: 20px;
          font-size: 12px;
          font-family: Microsoft YaHei-Regular;
          font-weight: 400;
          color: #ff7b1c;
        }

        .boutiqueTxt {
          margin-top: 12px;
          width: 255px;
          height: 26px;
          display: inline-block;
          padding: 0px 8px;
          line-height: 26px;
          font-size: 12px;
          background: none;
          background-image: url("https://staticfile.xlcwx.com/m-images/yth/lzjxy/img/Home/boutiqueTxt.png") !important;
          background-size: 100% 100%;
          color: #a57800;
          // padding-left: 83px;
        }

        .kecentsCenBtm {
          position: absolute;
          bottom: 18px;
          left: 16px;
          right: 16px;
          display: flex;
          justify-content: space-between;
          align-items: center;

          .boutiquePrice {
            color: #5a4629 !important;
          }

          .price {
            font-size: 18px;
            font-family: Microsoft YaHei-Regular;
            font-weight: bold;
            color: #ff5e51;
            line-height: 18px;

            .tips {
              font-size: 14px;
              font-weight: 400;
              line-height: 14px;
            }
          }

          .oldPrice {
            font-size: 16px;
            font-family: Microsoft YaHei-Regular;
            font-weight: 400;
            color: #999999;
            line-height: 16px;
            text-decoration: line-through;
            margin-left: 8px;
          }

          .more {
            font-size: 16px;
            font-family: Microsoft YaHei-Regular;
            font-weight: 400;
            color: #999999;
            line-height: 16px;
            margin-left: 8px;
            flex-shrink: 0;
            align-items: center;

            .img {
              width: 13px;
              height: 13px;
              margin-right: 5px;
            }
          }
        }
      }
    }
  }
}

.isNull {
  width: 1200px;
  margin: 0px auto;
}

.xbk {
  img {
    width: 60px !important;
    height: 22px !important;
    display: inline !important;
    margin-right: 8px !important;
    position: relative;
    top: 5px;
  }
}

.tagxbk {
  width: 45px;
  height: 21px;
  line-height: 21px;
  border-radius: 8px 0 8px 0;
  // background-image: url("https://staticfile.xlcwx.com/m-images/yth/lzjxy/img/smallban/bac.png");
  background-size: 45px 21px;
  color: #ffffff;
  text-align: center;
  font-size: 11px;
  position: absolute;
  top: 0;
  left: 0;

  img {
    transform: translateY(-8px);
    width: 60px !important;
    height: auto !important;
  }
}
</style>
